module.exports = __webpack_public_path__ + "static/media/presentation-togo.56ee681e.pdf";